import LabeledElement from '@rio-cloud/rio-uikit/LabeledElement';

type ExpanderFormContentProps = {
    label: string;
    value: string | number | React.ReactNode;
    className?: string;
    classNameValue?: string;
    boxed?: boolean;
    icon?: string;
};

const LabeledValue = ({ label, value, className, classNameValue, boxed = false, icon }: ExpanderFormContentProps) => (
    <div
        className={`${className ? className : ''} ${boxed ? 'bg-white padding-x-15 padding-y-10 shadow-subtle rounded' : ''}`}
    >
        <LabeledElement label={label} noGap />
        <div className={`text-size-14 display-flex gap-5 ${classNameValue ? classNameValue : ''}`}>
            {icon && <span className={`rioglyph rioglyph-${icon} text-color-dark padding-top-2`} />}
            {value}
        </div>
    </div>
);

export default LabeledValue;
